module.exports = __webpack_public_path__ + "8f0cd112ea2637de4ec549a83a6ae0e7.svg";